import { ButtonProtected } from '@components'

import { ButtonsGroup, useModal } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useIsOrganizationOwner } from '@modules-deprecated/app/organization/hooks/useIsOrganizationOwner'

import { ModalId } from '../../../../../../../../enums/modalId'
import { Scope } from '../../../../../../../../enums/scope'
import { TrackingContext } from '../../../../../../../../enums/trackingContext'

export const UsersSectionSideActions = (): ReactElement => {
  const { t } = useTranslation()
  const { isOrganizationOwner } = useIsOrganizationOwner()
  const { open: openInviteUsersModal } = useModal(ModalId.OrganizationSettingsInviteUsersModal)
  const { open: openTransferOwnershipModal } = useModal(ModalId.OrganizationSettingsTransferOwnershipModal)

  const handleTransferOwnershipButtonClick = useCallback(() => {
    openTransferOwnershipModal()
  }, [openTransferOwnershipModal])

  const handleInviteUserButtonClick = useCallback(() => {
    openInviteUsersModal()
  }, [openInviteUsersModal])

  return (
    <>
      <ButtonsGroup>
        {isOrganizationOwner && (
          <ButtonProtected
            scopes={Scope.UserTransferOwnership}
            trackingContext={TrackingContext.OrganizationSettingsUser}
            icon="refresh"
            onClick={handleTransferOwnershipButtonClick}
            variant="outlined"
          >
            {t('settings.organization.users.transfer_ownership_section.transfer_ownership')}
          </ButtonProtected>
        )}
        <ButtonProtected
          scopes={Scope.UserWrite}
          trackingContext={TrackingContext.OrganizationSettingsUser}
          icon="circlePlus"
          onClick={handleInviteUserButtonClick}
        >
          {t('settings.organization.users.invite_section.invite_user')}
        </ButtonProtected>
      </ButtonsGroup>
    </>
  )
}
